import { PersistentSharedState } from '@trello/shared-state';

interface BoardSwitcherSharedState {
  isOpen: boolean;
  isSpotlightOpen: boolean;
  selectedWorkspaceId: string | null;
  layout: 'grid' | 'list';
  mode: 'modal' | 'panel';
  expandSectionsState: Record<string, boolean>;
}

export const defaultBoardSwitcherSharedState: BoardSwitcherSharedState = {
  isOpen: false,
  isSpotlightOpen: false,
  selectedWorkspaceId: null,
  layout: 'grid',
  mode: 'modal',
  expandSectionsState: {},
};

export const boardSwitcherSharedState = new PersistentSharedState(
  defaultBoardSwitcherSharedState,
  { storageKey: 'boardSwitcherState' },
);
